<div class="delivery-type-icon" [matTooltip]="taskType.Title"
    [ngClass]="'delivery-type-icon--circle-' + (taskType | taskTypeColor) ">
    {{ taskType | taskTypeAcronym}}
</div>